module.exports = __webpack_public_path__ + "static/img/vi.97c5e4ae.png";